// components/const/Daily/DailySummary.jsx
import DocSummaryCard from "../../common/form/DocSummary";

export default function DailySummary({
  projectName,
  date,
  author,
  confirmer,
  weather,
  tempMin,
  tempMax,
  tempAvg,
  precipAvg,
  precipTotal,
  snowAvg,
  snowTotal,
  windAvg,
  windMax,
  todayWork,
  tomorrowWork,
  equipmentData,
  materialData,
  personnelData,
}) {
  return (
    <DocSummaryCard
      title="공사일보 요약"
      sections={[
        { label: "현장명", value: projectName },
        { label: "일자", value: date },
        { label: "작성자", value: author || "-" },
        { label: "확인자", value: confirmer || "-" },
        { label: "날씨", value: weather || "-" },
        {
          label: "기온",
          value: `${tempMin ?? "-"} ~ ${tempMax ?? "-"} °C (평균 ${
            tempAvg ?? "-"
          }°C)`,
        },
        {
          label: "강수량",
          value: `누계 ${precipTotal ?? "-"}mm / 평균 ${precipAvg ?? "-"}mm`,
        },
        {
          label: "적설량",
          value: `누계 ${snowTotal ?? "-"}cm / 평균 ${snowAvg ?? "-"}cm`,
        },
        {
          label: "풍속",
          value: `평균 ${windAvg ?? "-"}m/s / 최대 ${windMax ?? "-"}m/s`,
        },
      ]}
      blocks={[
        { label: "확정 작업사항", content: todayWork },
        { label: "예정 작업사항", content: tomorrowWork },
      ]}
      list={[
        {
          label: "자재 현황",
          items: materialData.map((m) => {
            const total = (m.prev_total ?? 0) + (Number(m.today) || 0);
            return `${m.name || "-"} (${m.spec || "-"}) - 금일 ${m.today ?? 0}${
              m.unit || ""
            }, 누계 ${total}${m.unit || ""}`;
          }),
        },
        {
          label: "장비 현황",
          items: equipmentData.map((e) => {
            const total = (e.prev_total ?? 0) + (Number(e.today) || 0);
            return `${e.name || "-"} (${e.spec || "-"}) - 금일 ${
              e.today ?? 0
            }, 누계 ${total}`;
          }),
        },
        {
          label: "인원 현황",
          items: personnelData.map((p) => {
            const total = (p.prev_total ?? 0) + (Number(p.today) || 0);
            return `${p.work_type || "-"} (${p.category || "-"}) - 금일 ${
              p.today ?? 0
            }, 누계 ${total}`;
          }),
        },
      ]}
      footerNote="※ 입력한 데이터가 요약됩니다. 실제 수정은 좌측 입력 영역에서 가능합니다."
    />
  );
}
